import FileSaver from "file-saver";
import {displayError} from "../common/notifications";
export const API_BASE_URL =
  localStorage.API_BASE_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  "https://staging.brdgx.com";

const request = (options, token) => {
  const headers = new Headers({
    "Content-Type": "application/json"
  });
  const isLoginRequest = options.url.includes("/login") || options.url.includes("/signup")|| options.url.includes("/forgot-password")|| options.url.includes("/reset-password");;

  if (
    localStorage.getItem("ACCESS_TOKEN") === "undefined" ||
      localStorage.getItem("ACCESS_TOKEN") === null ||
      localStorage.getItem("ACCESS_TOKEN") === "null"
  ) {
    localStorage.removeItem("ACCESS_TOKEN");
  }

  if (!!localStorage.getItem("ACCESS_TOKEN") && !isLoginRequest) {
    headers.append(
      "Authorization",
      `Bearer ${localStorage.getItem("ACCESS_TOKEN")}`
    );
    headers.append("X-test", "test");
  }

  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  return fetch(options.url, { headers, ...options}).then(response => {
    return response
      .json()
      .catch(() => Promise.reject(response))
      .then(json => {
        if (!response.ok) {
          return Promise.reject(json);
        }
        return json;
      });
  });
};

export function downloadOrderReceipt(name, orderId, fullOrderId) {
  const headers = new Headers({
    "Content-Type": "application/json"
  });

  if (
      localStorage.getItem("ACCESS_TOKEN") === "undefined" ||
      localStorage.getItem("ACCESS_TOKEN") === null ||
      localStorage.getItem("ACCESS_TOKEN") === "null"
  ) {
    localStorage.removeItem("ACCESS_TOKEN");
  }

  if (localStorage.getItem("ACCESS_TOKEN") != null) {
    headers.append(
        "Authorization",
        "Bearer " + localStorage.getItem("ACCESS_TOKEN")
    );
  }

  const defaults = { headers: headers, method: "POST"};

  let options = Object.assign({}, defaults);

  return fetch(API_BASE_URL + `/api/secured/orders/${orderId}/receipt`, options)
      .then(response => {
        return response.blob();
      })
      .then(blob => {
        FileSaver.saveAs(blob, name + `-${fullOrderId}.pdf`);
      });
}


export function uploadInvoice
({
   id,
   fileType,
   otherTypeDescription,
   remarks,
   file,
 }) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("name", "uploaded_file");
  formData.append("description", "Uploaded File");
  formData.append("other", otherTypeDescription);
  formData.append("remarks", remarks);

  let uploadEndpoint = `${API_BASE_URL}/api/secured/orders/${id}/upload?fileType=${fileType}`;

  return request({
    url: uploadEndpoint,
    method: "POST",
    body: formData,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("ACCESS_TOKEN")
    }
  });
}

export function getOrderAttachedFiles(orderId) {
  return request({
    url: API_BASE_URL + `/api/secured/orders/${orderId}/files`,
    method: "GET"
  });
}

// export function generateOrderFileDownloadLink(attachedFileId) {
//   return request({
//     url: API_BASE_URL + `/api/secured/order-files/${attachedFileId}/link`,
//     method: "GET"
//   });
// }

export function login(loginRequest) {
  return request({
    url: API_BASE_URL + "/api/auth/login",
    method: "POST",
    body: JSON.stringify(loginRequest)
  });
}
export function logout() {
  return request({
    url: API_BASE_URL + "/api/secured/auth/logout",
    method: "POST"
  });
}
export function renewAccessToken(token) {
  return request({
    url: API_BASE_URL + `/api/secured/auth/access-token`,
    method: "POST"
  });
}

export function createOrUpdateOriginator(customerId, originator) {
  let method = "POST";
  if(originator.id){
    method = "PUT";
  }
  return request({
    url: API_BASE_URL + "/api/secured/originators",
    method: method,
    body: JSON.stringify(originator)
  });
}

export function deleteAttachedFile(customerId, attachedFileId) {
  return request({
    url:
        API_BASE_URL +
        `/api/secured/customers/${customerId}/files/${attachedFileId}`,
    method: "DELETE"
  });
}

export function uploadOriginatorFile({
                                       id,
                                       fileType,
                                       otherTypeDescription,
                                       file,
                                       isCorporate = false,
                                     }) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("name", "uploaded_file");
  formData.append("description", "Uploaded File");
  formData.append("other", otherTypeDescription);

  let uploadEndpoint = `${API_BASE_URL}/api/secured/originators/${id}/upload?fileType=${fileType}`;
  if (isCorporate) {
    uploadEndpoint = `${API_BASE_URL}/api/secured/corporateOriginators/${id}/upload`;
    formData.append("fileType", fileType);
  }

  return request({
    url: uploadEndpoint,
    method: "POST",
    body: formData,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("ACCESS_TOKEN")
    }
  });
}

export function generateOriginatorFileDownloadLink(attachedFileId) {
  return request({
    url: API_BASE_URL + `/api/secured/originator-files/${attachedFileId}/link`,
    method: "GET"
  });
}

export function updateOriginatorAttachedFile(data) {
  return request({
    url: API_BASE_URL + `/api/secured/originator-files/${data.id}`,
    method: "PATCH",
    body: JSON.stringify(data)
  });
}

export function getOriginatorAttachedFiles(originatorId) {
  return request({
    url: API_BASE_URL + `/api/secured/originators/${originatorId}/files`,
    method: "GET"
  });
}

export function getAddressFromPostalCode(postalcode) {
  return request({
    url: API_BASE_URL + `/api/secured/onemap/postal-code/${postalcode}`,
    method: "GET"
  });
}

export function getCurrentCustomer(token) {
  return request(
    {
      url: API_BASE_URL + `/api/secured/customer`,
      method: "GET"
    },
    token
  );
}
export function findSchedule() {
  return request(
      {
        url: API_BASE_URL + `/api/secured/customer/find-schedule`,
        method: "GET"
      }
  );
}

export function getExchangeRates() {
  return request({
    url: API_BASE_URL + `/api/rates`,
    method: "GET"
  });
}

export function getTransferCalculatorConfiguration(sourceAmount = -1, customerTier = null,
                                                   beneficiaryType='CORPORATE', beneficiaryCountry=null, senderType, activeTabFee='LOCAL') {
  if(!senderType){
    senderType = '';
  }
  let url = "";
  if(customerTier !=null){
    url = `/api/transfer-calculator?sourceAmount=${sourceAmount}&customerTier=${customerTier}&beneficiaryType=${beneficiaryType}&beneficiaryCountry=${beneficiaryCountry}&senderType=${senderType}`;
  }else{
    url = `/api/transfer-calculator?sourceAmount=${sourceAmount}&beneficiaryType=${beneficiaryType}&beneficiaryCountry=${beneficiaryCountry}&senderType=${senderType}`;
  }
  if(activeTabFee){
    url = url + "&activeTabFee=" + activeTabFee.toUpperCase();
  }
  return request({
    url: API_BASE_URL + url,
    method: "GET"
  });
}

export function getTransferCalculatorConfigurationWithConvertAmount(sourceAmount = -1, customerTier = null,
                                                   beneficiaryType='CORPORATE', beneficiaryCountry=null, convertedAmount = undefined, senderType, activeTabFee='LOCAL') {
  if(!senderType){
    senderType = '';
  }
  let url = "";
  if(customerTier !=null){
    url = `/api/transfer-calculator?sourceAmount=${sourceAmount}&customerTier=${customerTier}&beneficiaryType=${beneficiaryType}&beneficiaryCountry=${beneficiaryCountry}&convertedAmount=${convertedAmount}&senderType=${senderType}`;
  }else{
    url = `/api/transfer-calculator?sourceAmount=${sourceAmount}&beneficiaryType=${beneficiaryType}&beneficiaryCountry=${beneficiaryCountry}&convertedAmount=${convertedAmount}&senderType=${senderType}`;
  }
  if(activeTabFee) {
    url = url + "&activeTabFee="+ activeTabFee.toUpperCase();
  }
  return request({
    url: API_BASE_URL + url,
    method: "GET"
  });
}
export function getFxRateRefApi (sourceAmount =1000, isRegularTier = false) {
  let params = `/api/secured/cust/fx-rate-reference?sourceAmount=${sourceAmount}&isRegularTier=${isRegularTier}`;
  return request({
    url: API_BASE_URL + params,
    method: "GET"
  });
}
export function switchSession () {

  return request({
    url: API_BASE_URL + "/api/secured/auth/switch",
    method: "GET"
  });
}
export function getTransactionLimitations() {
  return request({
    url: API_BASE_URL + `/api/transaction-limitation`,
    method: "GET"
  });
}

export function getBeneficiaries(page, pageSize, beneficiaryType =null, beneficiaryCountry = '', sourceCurrency ='', targetCurrency= '', sortKey='',sortType='') {
    let url = `/api/secured/beneficiaries?page=${page}&size=${pageSize}&beneficiaryCountry=${beneficiaryCountry}&sourceCurrency=${sourceCurrency}&targetCurrency=${targetCurrency}`;
  if(beneficiaryType){
     url +=`&beneficiaryType=${beneficiaryType}`;
  }

  if(sortKey){
    url +=`&sortKey=${sortKey}`;
  }
  if(sortType){
    url +=`&sortType=${sortType}`;
  }

  return request({
    url: API_BASE_URL + url,
    method: "GET"
  });
}

export function getBeneficiariesByOriginator(originatorId, page, pageSize, beneficiaryType = null, beneficiaryCountry = '', sourceCurrency ='', targetCurrency= '') {
  if(beneficiaryType != null){
    return request({
      url: API_BASE_URL + `/api/secured/originator/${originatorId}/beneficiaries?page=${page}&size=${pageSize}&beneficiaryType=${beneficiaryType}&beneficiaryCountry=${beneficiaryCountry}&sourceCurrency=${sourceCurrency}&targetCurrency=${targetCurrency}`,
      method: "GET"
    });
  }else {
    return request({
      url: API_BASE_URL + `/api/secured/originator/${originatorId}/beneficiaries?page=${page}&size=${pageSize}&beneficiaryCountry=${beneficiaryCountry}&sourceCurrency=${sourceCurrency}&targetCurrency=${targetCurrency}`,
      method: "GET"
    });
  }

}
export function getOriginatorsBySenderType(page =1, pageSize=20, senderType) {
  if(!senderType){
    senderType= ''
  }
  return request({
    url: API_BASE_URL + `/api/secured/originators?page=${page}&size=${pageSize}&senderType=${senderType}`,
    method: "GET"
  });
}
export function getOriginators(page =1, pageSize=20) {
  return request({
    url: API_BASE_URL + `/api/secured/originators?page=${page}&size=${pageSize}`,
    method: "GET"
  });
}
export function getOriginatorsByCustomer(customerId) {
  return request({
    url: API_BASE_URL + `/api/secured/customer/${customerId}/originators`,
    method: "GET"
  });
}
export function saveBeneficiary(beneficiary) {
  let method = "POST";
  if(beneficiary.id) {
    method = "PUT";
  }
  return request({
    url: API_BASE_URL + "/api/secured/beneficiaries",
    method: method,
    body: JSON.stringify(beneficiary)
  });
}
export function updateAddressBeneficiary(beneficiaryId, address) {
  return request({
    url: API_BASE_URL + `/api/secured/beneficiaries/${beneficiaryId}?address=${address}`,
    method: "PUT"
  });
}


export function saveOriginator(beneficiary) {
  return request({
    url: API_BASE_URL + "/api/secured/originators",
    method: "POST",
    body: JSON.stringify(beneficiary)
  });
}

export function createOrder(parameters) {
  return parameters.id ? request({
    url: API_BASE_URL + `/api/secured/orders/${parameters.id}`,
    method: "PUT",
    body: JSON.stringify(parameters)
  }) : request({
    url: API_BASE_URL + "/api/secured/orders",
    method: "POST",
    body: JSON.stringify(parameters)
  });
}

export function createVaSettleOrder(parameters) {
  return parameters.id ? request({
    url: API_BASE_URL + `/api/secured/vasettle/${parameters.id}`,
    method: "PUT",
    body: JSON.stringify(parameters)
  }) : request({
    url: API_BASE_URL + "/api/secured/vasettle",
    method: "POST",
    body: JSON.stringify(parameters)
  });
}

export function cancelOrder(orderId, remarks='') {
  return request({
    url: API_BASE_URL + `/api/secured/orders/${orderId}/status/cancel?remarks=${remarks}`,
    method: "PUT"
  });
}
export function approvalOrder(orderId) {
  return request({
    url: API_BASE_URL + `/api/secured/orders/${orderId}/status/approval`,
    method: "PUT"
  });
}
export function authorizelOrder(orderId) {
  return request({
    url: API_BASE_URL + `/api/secured/orders/${orderId}/status/authorizer`,
    method: "PUT"
  });
}


export function getCustomerOrders(page, size, orderIdSearch = "", orderStatus = "", sourceCurrency = "", targetCurrency = "", sortKey = "", sortType = "") {
  orderIdSearch = orderIdSearch ? orderIdSearch : "";
  orderStatus = orderStatus ? orderStatus : "";
  sourceCurrency = sourceCurrency ? sourceCurrency : "";
  targetCurrency = targetCurrency ? targetCurrency : "";
  sortKey = sortKey ? sortKey : "";
  sortType = sortType ? sortType : "";
  // console.log("API Params:", {page, size, orderIdSearch, orderStatus, sourceCurrency, targetCurrency, sortKey, sortType});
  return request({
    url: API_BASE_URL + `/api/secured/orders?page=${page}&size=${size}&orderIdSearch=${orderIdSearch}&orderStatus=${orderStatus}&sourceCurrency=${sourceCurrency}&targetCurrency=${targetCurrency}&sortKey=${sortKey}&sortType=${sortType}`,
    method: "GET"
  });
}


export function getCustomerPendingApprovalOrder(page, size){
  return request({
    url: API_BASE_URL + `/api/secured/orders/pending-approval?page=${page}&size=${size}`,
    method: "GET"
  });
}
export function getOrderStatusByBeneficiaryId(beneficiaryId) {
  return request({
    url: API_BASE_URL + `/api/secured/orders/beneficiary/${beneficiaryId}`,
    method: "GET"
  });
}

export function getOrderStatusByOriginatorId(originatorId) {
  return request({
    url: API_BASE_URL + `/api/secured/orders/originator/${originatorId}`,
    method: "GET"
  });
}

export function lockExchangeRate(sourceCurrency, targetCurrency, amount, beneficiaryType='PERSONAL', senderType
                                 , beneficiaryCountry, convertedAmount,activeTabFee='LOCAL',swiftFee) {
  let url = "";
  if(activeTabFee){
    activeTabFee=activeTabFee.toUpperCase();
  }else{
    activeTabFee="LOCAL";
  }
  if(!swiftFee){
    swiftFee = 0;
  }
  if(convertedAmount){
    url = `/api/secured/rates/lock?sourceCurrency=${sourceCurrency}&targetCurrency=${targetCurrency}&amount=${amount}&beneficiaryType=${beneficiaryType}&senderType=${senderType}&beneficiaryCountry=${beneficiaryCountry}&convertedAmount=${convertedAmount}&activeTabFee=${activeTabFee}&swiftFee=${swiftFee}`;
  }else{
    url = `/api/secured/rates/lock?sourceCurrency=${sourceCurrency}&targetCurrency=${targetCurrency}&amount=${amount}&beneficiaryType=${beneficiaryType}&senderType=${senderType}&beneficiaryCountry=${beneficiaryCountry}&activeTabFee=${activeTabFee}&swiftFee=${swiftFee}`;
  }
  return request({
    url:
        API_BASE_URL +
        url,
    method: "POST"
  });

}

export function doChangeFxRateApi(selectedReceivedOrder) {
    return request({
      url: API_BASE_URL + "/api/secured/cust/order/change-fx-rate",
      method: "PUT",
      body: JSON.stringify(selectedReceivedOrder)
    }).catch(e => {
      throw e;
    });
}

export function deleteBeneficiary(id) {
  return request({
    url: API_BASE_URL + `/api/secured/beneficiaries/${id}`,
    method: "DELETE"
  });
}

export function deleteOriginator(id) {
  return request({
    url: API_BASE_URL + `/api/secured/originators/${id}`,
    method: "DELETE"
  });
}

export function changePassword(changePasswordRequest) {
  return request({
    url: API_BASE_URL + `/api/secured/customer/password`,
    method: "POST",
    body: JSON.stringify(changePasswordRequest)
  });
}
export function changePasswordInFirstTime(changePasswordRequest) {
  return request({
    url: API_BASE_URL + `/api/secured/customer/change-password-in-first-time`,
    method: "POST",
    body: JSON.stringify(changePasswordRequest)
  });
}
export function signup(data) {
  return request({
    url: API_BASE_URL + `/api/signup-customer-web-account`,
    method: "POST",
    body: JSON.stringify(data)
  });
}

export function submitPhoneNumber(data, token) {
  return request(
    {
      url: API_BASE_URL + `/api/customer/phone`,
      method: "PUT",
      body: JSON.stringify(data)
    },
    token
  );
}
export function submitOTPChangePassword(otp,currentPassword, password, url, token) {
  let otpEndpoint;

  if (!url) {
    otpEndpoint = API_BASE_URL + `/api/secured/customer/otp`;
  } else {
    otpEndpoint = API_BASE_URL + url;
  }

  return request(
      {
        url: otpEndpoint,
        method: "POST",
        body: JSON.stringify({ otp, currentPassword, password })
      },
      token
  );
}
export function submitOTP(otp, url, token, username, password) {
  let otpEndpoint;

  if (!url) {
    otpEndpoint = API_BASE_URL + `/api/customer/otp`;
  } else {
    otpEndpoint = API_BASE_URL + url;
  }

  return request(
    {
      url: otpEndpoint,
      method: "POST",
      body: JSON.stringify({ otp, username, password })
    },
    token
  );
}
export function generateAccessToken() {
  return request(
      {
        url: API_BASE_URL + `"/api/customer/totp/authy/accessToken`,
        method: "POST"
      }
  );
}
export function createCorporateAccountDetails(data) {
  return request({
    url: API_BASE_URL + `/api/secured/corporates`,
    method: "POST",
    body: JSON.stringify(data)
  });
}

export function getSourceOfFundCode(token) {
  return request({
    url: API_BASE_URL + `/api/secured/code/source-of-fund-code`,
    method: "GET"
  }, token);
}

export function updateCustomerAccount(data) {
  return request({
    url: API_BASE_URL + `/api/secured/customer`,
    method: "PUT",
    body: JSON.stringify(data)
  });
}

export function updateCustomerAccountMyInfo(data) {
  return request({
    url: API_BASE_URL + `/api/secured/customer-myinfo`,
    method: "PUT",
    body: JSON.stringify(data)
  });
}


export function setupSchedule(data) {
  return request({
    url: API_BASE_URL + `/api/secured/customer/setup-schedule`,
    method: "PUT",
    body: JSON.stringify(data)
  });
}
export function getCorporateAccountDetails() {
  return request({
    url: API_BASE_URL + `/api/secured/corporates`
  });
}

export function upload({
  id,
  isCorporateUsers = false,
  isOriginatorUpload = false,
  type,
  params = "",
  file
}) {
  const body = new FormData();
  body.append("file", file);
  body.append("other", file.type);
  body.append("fileType", type);

  let uploadEndpoint = `${API_BASE_URL}/api/secured/corporates/${id}/upload${params}`;
  if (isCorporateUsers) {
    uploadEndpoint = `${API_BASE_URL}/api/secured/corporateusers/${id}/upload${params}`;
  } else if (isOriginatorUpload){
    uploadEndpoint = `${API_BASE_URL}/api/secured/originator/${id}/upload${params}`;
  }

  return fetch(uploadEndpoint, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("ACCESS_TOKEN")
    },
    body,
    method: "POST"
  }).then(response => {
    return response
      .json()
      .catch(() => Promise.reject(response))
      .then(json => {
        if (!response.ok) {
          return Promise.reject(json);
        }
        return json;
      });
  });
}

export function createCorporateAccountUser(data) {
  return request({
    url: API_BASE_URL + `/api/secured/corporateusers`,
    method: "POST",
    body: JSON.stringify(data)
  });
}

export function updateCorporateAccountUser(data) {
  return request({
    url: API_BASE_URL + `/api/secured/corporateusers/${data.id}`,
    method: "PATCH",
    body: JSON.stringify(data)
  });
}

export function getCurrentCorporateAccountUser() {
  return request({
    url: API_BASE_URL + `/api/secured/corporateusers/current`,
    method: "GET"
  });
}

export function updateCurrentCorporateAccountUser(data) {
  return request({
    url: API_BASE_URL + `/api/secured/corporateusers/current`,
    method: "PATCH",
    body: JSON.stringify(data)
  });
}

export function updateCurrentCorporateAccountUserMyInfo(myInfoResource) {
  return request({
    url: API_BASE_URL + `/api/secured/corporateusers/current/myinfo`,
    method: "PUT",
    body: JSON.stringify(myInfoResource)
  });
}

export function getOnboardingLinkToken(ref, code) {
  return request({
    url: API_BASE_URL + `/api/onboarding-link/${ref}/${code}`,
    method: "GET"
  });
}

export function requestResetPassword(email) {
  return request({
    url: API_BASE_URL + "/api/forgot-password",
    method: "POST",
    body: JSON.stringify({ email })
  });
}

export function resetPassword({ password, token, id }) {
  return request({
    url: API_BASE_URL + "/api/reset-password",
    method: "POST",
    body: JSON.stringify({ newPassword: password, token, id })
  });
}

export function getCorporateAccountUserDetails(id) {
  return request({
    url: API_BASE_URL + `/api/secured/corporates/${id}/users`
  });
}

export function getOTP(token) {
  return request(
    {
      url: API_BASE_URL + "/api/secured/customer/resend-otp"
    },
    token
  );
}

export function deleteFile(id) {
  return request({
    url: `${API_BASE_URL}/api/secured/files/${id}`,
    method: "DELETE"
  });
}
export function deleteOrderAttachedFile(orderId, attachedFileId) {
  return request({
    url:
        API_BASE_URL +
        `/api/secured/orders/${orderId}/files/${attachedFileId}`,
    method: "DELETE"
  });
}

export function deleteOriginatorAttachedFile(originatorId, fileId) {
  return request({
    url: `${API_BASE_URL}/api/secured/originator/${originatorId}/files/${fileId}`,
    method: "DELETE"
  });
}

export function deleteCorporateUser(id) {
  return request({
    url: `${API_BASE_URL}/api/secured/corporateusers/${id}`,
    method: "DELETE"
  });
}

// export function generateCustomerFileDownloadLink(attachedFileId, isOriginatorAttachedFile=false, isOrderFile = false) {
//   let url = API_BASE_URL + `/api/secured/customer-files/${attachedFileId}/link`;
//   // if(isOriginatorAttachedFile){
//   //   url = API_BASE_URL + `/api/secured/cust/originator/files/${attachedFileId}/link`
//   // }
//   // if(isOrderFile){
//   //   return generateOrderFileDownloadLink(attachedFileId);
//   // }
//
//   return request({
//     url: url,
//     method: "GET"
//   });
// }

export function generateUploadedFile(attachedFileId, isOriginatorAttachedFile=false, isOrderFile = false) {
  let url = API_BASE_URL + `/api/secured/cust/customer/files/${attachedFileId}`;
  if(isOriginatorAttachedFile){
    url = API_BASE_URL + `/api/secured/cust/originator/files/${attachedFileId}`
  }

  if(isOrderFile) {
    url = API_BASE_URL + `/api/secured/cust/order/files/${attachedFileId}`
  }

  const headers = new Headers({});

  if (localStorage.getItem("ACCESS_TOKEN") != null) {
    headers.append(
        "Authorization",
        "Bearer " + localStorage.getItem("ACCESS_TOKEN")
    );
  }else {
    alert("There is no access token. Please login again")
    return;
  }

  const defaults = { headers: headers, method: "GET"};

  let options = Object.assign({}, defaults);

  return fetch(url, options
  ).then(response => {
    var name = response.headers.get("fileName");
    response.blob().then(function(myBlob) {
      // console.log(...response.headers);
      var url = URL.createObjectURL(myBlob);
      const a = document.createElement('a');
      a.href = url;
      a.download = name;
      a.click();
    });
  });
}

export function generateUploadedFileNotDownload(attachedFileId, isOriginatorAttachedFile=false, isOrderFile = false) {
  let url = API_BASE_URL + `/api/secured/cust/customer/files/${attachedFileId}`;
  if(isOriginatorAttachedFile){
    url = API_BASE_URL + `/api/secured/cust/originator/files/${attachedFileId}`
  }

  if(isOrderFile) {
    url = API_BASE_URL + `/api/secured/cust/order/files/${attachedFileId}`
  }

  const headers = new Headers({});

  if (localStorage.getItem("ACCESS_TOKEN") != null) {
    headers.append(
        "Authorization",
        "Bearer " + localStorage.getItem("ACCESS_TOKEN")
    );
  }else {
    alert("There is no access token. Please login again")
    return;
  }

  const defaults = { headers: headers, method: "GET"};

  let options = Object.assign({}, defaults);

  return fetch(url, options
  ).then(response => {
    var name = response.headers.get("fileName");
    return response.blob().then(function(myBlob) {
      // console.log(...response.headers);
      var url = URL.createObjectURL(myBlob);
      const a = document.createElement('a');
      a.href = url;
      a.download = name;
      return url;
    });
  });
}

export function getPayNowQrImage(orderId) {
  let url = API_BASE_URL + `/api/secured/cust/paynowqr/${orderId}`;

  const headers = new Headers({});

  if (localStorage.getItem("ACCESS_TOKEN") != null) {
    headers.append(
        "Authorization",
        "Bearer " + localStorage.getItem("ACCESS_TOKEN")
    );
  }else {
    alert("There is no access token. Please login again")
    return;
  }

  const defaults = { headers: headers, method: "GET"};

  let options = Object.assign({}, defaults);

  return fetch(url, options
  ).then(response => {
    return response.blob().then(function(myBlob) {
      return URL.createObjectURL(myBlob);
    });
  });
}

export function submitDocumentCorporateAccount(onboardingType='timeSchedule') {
  return request({
    url: API_BASE_URL + `/api/secured/corporates?onboardingType=${onboardingType}`,
    method: "PUT"
  });
}

export function submitMyInfo(onboardingType='timeSchedule' ) {
  return request({
    url: API_BASE_URL + `/api/secured/corporates?onboardingType=${onboardingType}`,
    method: "PUT"
  });
}
export function generateAuthyFactor(data){
  return request(
      {
        url: API_BASE_URL + `/api/customer/totp/authy/factor`,
        method: "POST",
        body: JSON.stringify(data)
      }
  );
}
export function verifyAuthyFactor(data){
  return request(
      {
        url: API_BASE_URL + `/api/customer/totp/authy/factor`,
        method: "PUT",
        body: JSON.stringify(data)
      }
  );
}
export function getDownloadAcceptanceForm() {
  const params = new URLSearchParams()
  params.append('access_token', localStorage.getItem('ACCESS_TOKEN'))

  return `${API_BASE_URL}/api/secured/acceptance-form?${params}`
}


export function getNationalityList() {
  return request({
    url: API_BASE_URL + `/api/secured/nationality/list`,
    method: "GET"
  });
}
export function getCountryList() {
  return request({
    url: API_BASE_URL + `/api/secured/country/list`,
    method: "GET"
  });
}


export function getCompanyType() {
  return request({
    url: API_BASE_URL + `/api/secured/code/company-type`,
    method: "GET"
  });
}

export function getIdType() {
  return request({
    url: API_BASE_URL + `/api/secured/code/id-type`,
    method: "GET"
  });
}
export function getOccupationCode() {
  return request({
    url: API_BASE_URL + `/api/secured/code/occupation-code`,
    method: "GET"
  });
}
export function getIndustryCode() {
  return request({
    url: API_BASE_URL + `/api/secured/code/industry-code`,
    method: "GET"
  });
}

export function getBankCode(country) {
  return request({
    url: API_BASE_URL + `/api/secured/country/${country}/bank`,
    method: "GET"
  });
}
export function getRelationshipCode() {
  return request({
    url: API_BASE_URL + `/api/secured/code/relationship-code`,
    method: "GET"
  });
}

export function geRemittanceCode() {
  return request({
    url: API_BASE_URL + `/api/secured/code/remittance-code`,
    method: "GET"
  });
}

export function getAccountBalance() {
  return request({
    url: API_BASE_URL + `/api/secured/customer/balance`,
    method: "GET"
  });
}

export function getVirtualAccountBalance() {
  return request({
    url: API_BASE_URL + `/api/secured/customer/virtualaccountbalance`,
    method: "GET"
  });
}

export function getVirtualAccountBalanceByVirtualAccId(virtualAccId, isBeneVA=true) {
  return request({
    url: API_BASE_URL + `/api/secured/cust/virtual-acc-balance?virtualAccId=${virtualAccId}&beneVa=${isBeneVA}`,
    method: "GET"
  });
}

export function getVirtualAccountSubAccountBalance() {
  return request({
    url: API_BASE_URL + `/api/secured/customer/virtualaccount/subaccount/balance`,
    method: "GET"
  });
}

export function getBankSubledgerSubAccountBalance() {
  return request({
    url: API_BASE_URL + `/api/secured/customer/banksubledger/subaccount/balance`,
    method: "GET"
  });
}

export function getCustomerTransactions() {
  return request({
    url: API_BASE_URL + `/api/secured/customer/customertxns`,
    method: "GET"
  });
}

export function getBeneficiaryVirtualAccountNumbers() {
  return request({
    url: API_BASE_URL + `/api/secured/beneficiary/virtualaccountnumbers`,
    method: "GET"
  });
}

export function getCurrencyCountry() {
  return request({
    url: API_BASE_URL + `/api/secured/code/currency-country`,
    method: "GET"
  });
}

export function getSourceAccountCurrency(currency) {
  return request({
    url: API_BASE_URL + `/api/secured/customer/source-currency/${currency}`,
    method: "GET"
  });

}

export function getHongKongSourceAccountCurrency() {
  return request({
    url: API_BASE_URL + `/api/secured/customer/hk-source-currency`,
    method: "GET"
  });

}

export function getGeoLocation() {
  return request({
    url: API_BASE_URL + `/api/ip-geo-location`,
    method: "GET"
  });
}
export function verifiedConfirmStatus(data, token) {
  return request(
      {
        url: API_BASE_URL + `/api/secured/customer/verifiedConfirmStatus`,
        method: "PUT",
        body: JSON.stringify(data)
      },
      token
  );
}
export function callbackMyInfo(code, state, error, error_description, code_verifier, oauth_state, oauth_nonce) {
 let myInfoUrl = `/pages/onboarding/myinfo/complete?code=${code}&state=${state}&code_verifier=${code_verifier}&oauth_state=${oauth_state}&oauth_nonce=${oauth_nonce}`
  if(error){
    myInfoUrl = `/pages/onboarding/myinfo/complete?code=${code}&state=${state}&code_verifier=${code_verifier}&oauth_state=${oauth_state}&oauth_nonce=${oauth_nonce}&error=${error}&error_description=${error_description}`
  }
  return request({
    url: API_BASE_URL + myInfoUrl,
    method: "GET",
    credentials: 'same-origin'
  });
}
// export function retrieveMyInfo(myinfoCode) {
//   return request({
//     url: API_BASE_URL + `/api/secured/myinfo/details`,
//     method: "POST",
//     body: JSON.stringify({ authoriseCode: myinfoCode})
//   });
// }
export function getSourceSupportedCurrencyFromCustomizedRateByCustomerTier(customertier) {
  return request({
    url: API_BASE_URL + `/api/transfer-calculator/source-currency/customer-tier/${customertier}`,
    method: "GET"
  });
}
export function getTargetSupportedCurrencyFromCustomizedRateByCustomerTier(customertier) {
  return request({
    url: API_BASE_URL + `/api/transfer-calculator/target-currency/customer-tier/${customertier}`,
    method: "GET"
  });
}
export function  checkDocumentUploadedCorpCustomerAccount() {
  return request({
    url: API_BASE_URL + `/api/secured/customer/document-corp-uploaded`,
    method: "GET"
  });
}

export function getTransactionCurrencies() {
  return request({
    url: API_BASE_URL + `/api/secured/customer/currencies`,
    method: "GET"
  });
}

export function getTransactionHistory(currency, pageNumber) {
  if (!pageNumber || pageNumber == 0) {
    return request({
      url: API_BASE_URL + `/api/secured/customer/entries?currency=${currency}`,
      method: "GET"
    });
  } else {
    return request({
      url: API_BASE_URL + `/api/secured/customer/entries?currency=${currency}&page=${pageNumber}`,
      method: "GET"
    });
  }
}

export function searchOrderIdForSelector(value) {
  return request({
    url: API_BASE_URL + "/api/secured/cust/orderId/search?string=" + value,
    method: "GET"
  });
}

export function searchOriginatorNameForSelector(value) {
  return request({
    url: API_BASE_URL + "/api/secured/cust/originator/search?string=" + value,
    method: "GET"
  });
}

export function searchOriginatorNameForSelectorWithCancelSignal(value, cancelSignal) {
  return request({
    url: API_BASE_URL + "/api/secured/cust/originator/search?string=" + value,
    method: "GET",
    signal: cancelSignal,
  });
}

export function searchBeneficiaryNameForSelector(value, originatorId, beneficiaryCountry = '', sourceCurrency ='', targetCurrency= '') {
  var params = 'string=' + value;
  if (originatorId) {
    params = params + '&originatorId=' + originatorId
  }
  return request({
    url: API_BASE_URL + `/api/secured/cust/beneficiary/search?` + params +`&beneficiaryCountry=${beneficiaryCountry}&sourceCurrency=${sourceCurrency}&targetCurrency=${targetCurrency}`,
    method: "GET"
  });
}

export function getBeneficiaryById(beneficiaryId) {
  return request({
    url: API_BASE_URL + `/api/secured/cust/beneficiary/${beneficiaryId}`,
    method: "GET"
  });
}

export function getOriginatorById(originatorId) {
  return request({
    url: API_BASE_URL + `/api/secured/cust/originator/${originatorId}`,
    method: "GET"
  });
}

export async function doGenerateReportClick(from,to, reportType, currencies) {
let urlSearchParams = new URLSearchParams();
  let token = localStorage.getItem("ACCESS_TOKEN");
  // urlSearchParams.append('access_token', token)
  if(from) {
    urlSearchParams.set('from',from);
  }
  if(to) {
    urlSearchParams.set('to',to);
  }
  if(reportType) {
    urlSearchParams.set('reportType',reportType);
  }
  if(currencies) {
    urlSearchParams.set('sourceCurrency',currencies);
  }

  let url = API_BASE_URL + `/api/secured/cust/generate-report?${urlSearchParams}`;
  const options = {
    headers: {
      Authorization:  + token
    }
  };
  return request ({
    url: url,
    method:"GET"
  })
}

export function doExportOrder(from,to, reportType, currencies) {
  let urlSearchParams = new URLSearchParams();
  let token = localStorage.getItem("ACCESS_TOKEN");
  if(!token) {
    displayError("Session is expired!!!");
    return;
  }
  if(from) {
    urlSearchParams.set('from',from);
  }
  if(to) {
    urlSearchParams.set('to',to);
  }
  if(reportType) {
    urlSearchParams.set('reportType',reportType);
  }
  if(currencies) {
    urlSearchParams.set('sourceCurrency',currencies);
  }

  let url = API_BASE_URL + `/api/secured/cust/generate-report?${urlSearchParams}`;
  const options = {
    headers: {
      Authorization:  "Bearer " + token,
      method: 'GET'
    }
  };
  return fetch(url, options
  ).then(response => {
    var name = response.headers.get("fileName");
    return response.blob().then(function(myBlob) {
      var url = URL.createObjectURL(myBlob);
      return {link:url, name:name};
    });
  });
}

export function getNewBatchUploads(page, size, filters = {}) {
  const { status, dateFrom, dateTo } = filters;
  
  let queryParams = new URLSearchParams({
    page: page,
    size: size
  });
  
  if (status) {
    queryParams.append('status', status);
  }
  
  if (dateFrom) {
    queryParams.append('dateFrom', dateFrom);
  }
  
  if (dateTo) {
    queryParams.append('dateTo', dateTo);
  }

  const url = `${API_BASE_URL}/api/secured/cust/batch-upload?${queryParams.toString()}`;

  return request({
    url: url,
    method: "GET"
  });
}

export function downloadBankTransferTemplateFile(fileType) {
  const headers = new Headers({
    "Content-Type": "application/json"
  });

  if (
      localStorage.getItem("ACCESS_TOKEN") === "undefined" ||
      localStorage.getItem("ACCESS_TOKEN") === null ||
      localStorage.getItem("ACCESS_TOKEN") === "null"
  ) {
    localStorage.removeItem("ACCESS_TOKEN");
  }

  if (localStorage.getItem("ACCESS_TOKEN") != null) {
    headers.append(
        "Authorization",
        "Bearer " + localStorage.getItem("ACCESS_TOKEN")
    );
  }

  const defaults = { headers: headers, method: "POST"};

  let options = Object.assign({}, defaults);

  let path = `/api/secured/cust/bank-transfer-template/download`;
  if(fileType) {
    path = path + "?fileType=" + fileType;
    return fetch(API_BASE_URL + path, options)
        .then(response => {
          return response.blob();
        })
        .then(blob => {
          FileSaver.saveAs(blob,'order_batch_template.' + fileType);
        });
  }
  return fetch(API_BASE_URL + path, options)
      .then(response => {
        return response.blob();
      })
      .then(blob => {
        FileSaver.saveAs(blob,'order_batch_template.csv');
      });
}

export function uploadBatchTransferFile(file) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('name', 'uploaded_file');
  formData.append('description', 'Uploaded File');

  return request({
    url: API_BASE_URL + `/api/secured/cust/batch/upload`,
    method: 'POST',
    body: formData,
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem("ACCESS_TOKEN")
    }
  });
}

export function downloadBatchFile (attachedFileId) {
  let url = API_BASE_URL + `/api/secured/cust/batch-upload/download/${attachedFileId}`;

  const headers = new Headers({});

  if (localStorage.getItem("ACCESS_TOKEN") != null) {
    headers.append(
        "Authorization",
        "Bearer " + localStorage.getItem("ACCESS_TOKEN")
    );
  }else {
    alert("There is no access token. Please login again")
    return;
  }

  const defaults = { headers: headers, method: "GET"};

  let options = Object.assign({}, defaults);

  return fetch(url, options
  ).then(response => {
    var name = response.headers.get("fileName");
    response.blob().then(function(myBlob) {
      var url = URL.createObjectURL(myBlob);
      const a = document.createElement('a');
      a.href = url;
      a.download = name;
      a.click();
    });
  });
}

export function createOTPEmail(customer) {
  return request({
    url: API_BASE_URL+"/api/cust/otp/email",
    method:'PUT',
    body: JSON.stringify(customer)
  });
}

export function linkBeneficiaryToDBS(beneficiary) {
  return request({
    url: API_BASE_URL + "/api/secured/cust/beneficiary/link-to-dbs",
    method: "POST",
    body: JSON.stringify(beneficiary)
  });
}

export function linkBeneficiaryToFlashFx(beneficiary) {
  return request({
    url: API_BASE_URL + "/api/secured/cust/beneficiary/link-to-flashfx",
    method: "POST",
    body: JSON.stringify(beneficiary)
  });
}

export function linkOriginatorToDBS(originator) {
  return request({
    url: API_BASE_URL + "/api/secured/cust/originator/link-to-dbs",
    method: "POST",
    body: JSON.stringify(originator)
  });
}


export function checkBeneficiaryHasOrder (beneficiaryId) {
  return request({
    url: API_BASE_URL + `/api/secured/cust/beneficiary/order?beneficiaryId=${beneficiaryId}`,
    method: 'GET',
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem("ACCESS_TOKEN")
    }
  })
}

export function doLoadReportHistory (page,size) {
  return request({
    url: API_BASE_URL + `/api/secured/cust/report/history?page=${page}&size=${size}`,
    method: 'GET',
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem("ACCESS_TOKEN")
    }
  });
}

export function getDownloadLinkFiles(key) {

  let url = API_BASE_URL + `/api/secured/cust/file?key=${key}`;

  const headers = new Headers({});

  if (localStorage.getItem("ACCESS_TOKEN") != null) {
    headers.append(
        "Authorization",
        "Bearer " + localStorage.getItem("ACCESS_TOKEN")
    );
  }else {
    alert("There is no access token. Please login again")
    return;
  }

  const defaults = { headers: headers, method: "GET"};

  let options = Object.assign({}, defaults);

  return fetch(url, options
  ).then(response => {
    var name = response.headers.get("fileName");
    return response.blob().then(function(myBlob) {
      var url = URL.createObjectURL(myBlob);
      return {link:url, name:name};
    });
  });

}


export function checkingDuplicationBankInfo (customerId, beneficiary) {
  return request({
    url:
        API_BASE_URL +
        `/api/secured/customer/${customerId}/beneficiary-bank`,
    method: "POST",
    body: JSON.stringify(beneficiary)
  });
}

export function fetchBankTransactionLinks(bankTransactionId) {
  return request({
    url: API_BASE_URL + `/api/secured/transaction/${bankTransactionId}/link`,
    method: 'GET'
  });
}

export function countBeneVAOfCustomerApi () {
  return request({
    url: API_BASE_URL + `/api/secured/cust-web/count-beneficiary-va`,
    method: 'GET'
  });
}

export function callAccountRippleBalanceApi () {
  return request({
    url: API_BASE_URL + `/api/secured/customer-web/ripple/balances`,
    method: "GET",

  });
}


